import {
    Typography,
} from '@mui/material'
import {
    Link,
} from 'react-router-dom'

import {
    Link as LinkType,
} from '../../MainMenu.types'
import useStyles from './MenuDropdown.styles'
import useSmartDropdownPositioning from './hooks/useSmartDropdownPositioning'

const LINK_HEIGHT = 50

type Props = {
    links: LinkType[],
}
const MenuDropdown = ({
    links,
}: Readonly<Props>) => {
    const {
        classes,
    } = useStyles()

    const {
        containerRef,
        dropdownRef,
        handleMouseEnter,
        handleMouseLeave,
        isVisible,
        positionStyles,
    } = useSmartDropdownPositioning({
        dropdownItemCount: links.length,
        dropdownItemHeight: LINK_HEIGHT,
    })

    return (
        <div
            ref={containerRef}
            className={classes.container}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            data-testid="menu-dropdown-container"
        >
            {isVisible && (
                <div
                    ref={dropdownRef}
                    className={classes.dropdown}
                    style={positionStyles}
                    data-testid="menu-dropdown"
                >
                    {links.map(({
                        title,
                        url,
                    }) => {
                        return (
                            <div
                                key={`menu-link-${title}`}
                                className={classes.linkContainer}
                            >
                                <Link
                                    className={classes.link}
                                    to={url}
                                >
                                    <Typography
                                        variant="h5"
                                        className={classes.linkLabel}
                                    >
                                        {title}
                                    </Typography>
                                </Link>
                                <div className={classes.underline} />
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    )
}

export default MenuDropdown
